import { getAuth } from "firebase/auth";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

async function leoRequest(path, params = {}) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  if (!token) return { success: false, actions: [] };
  const q = new URLSearchParams(params).toString();
  const url = `${API_BASE_URL}/leo${path}${q ? `?${q}` : ""}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return { success: false, actions: [] };
  return res.json();
}

/**
 * Pulse feed: 3 most recent Leo actions (automated/scheduled). Used by the Leo page and optional dashboard widget.
 * @param {string} ownerId - Firebase UID
 */
export async function getLeoPulse(ownerId) {
  if (!ownerId) return { success: true, actions: [] };
  return leoRequest("/pulse", { ownerId, limit: 3 });
}

/**
 * Actions requiring attention (Guardian + other high-priority). For Portfolio Health alert cards.
 * @param {string} ownerId - Firebase UID
 */
export async function getLeoRequiringAttention(ownerId) {
  if (!ownerId) return { success: true, actions: [] };
  return leoRequest("/requiring-attention", { ownerId });
}

/**
 * Authenticated: sum of timeSavedMinutes on Leo actions (last N days).
 * @param {{ days?: number }} opts
 */
export async function getLeoAiTimeSaved(opts = {}) {
  const user = getAuth().currentUser;
  if (!user) {
    return {
      success: false,
      totalMinutes: 0,
      totalHours: 0,
      actionCount: 0,
      daysBack: 90,
    };
  }
  const token = await user.getIdToken();
  const days = opts.days != null ? Number(opts.days) : 90;
  const q = new URLSearchParams({
    days: String(Number.isFinite(days) ? days : 90),
  }).toString();
  const res = await fetch(`${API_BASE_URL}/leo-dashboard/time-saved?${q}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    return {
      success: false,
      totalMinutes: 0,
      totalHours: 0,
      actionCount: 0,
      daysBack: 90,
    };
  }
  return data;
}
